<script>
import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    chartdata2: {
      labels: [],
      datasets: [
        {
          order: 2,
          type: 'bar',
          label: 'Số lượt',
          barPercentage: 0.8,
          backgroundColor: '#f87979',
          data: []
        },
        {
          order: 1,
          type: 'line',
          label: 'Xu hướng',
          backgroundColor: '#ffffff00',
          borderColor: 'rgb(75, 192, 192)',
          data: []
        }
      ]
    },
    options: {
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Tháng trong năm'
          }
        }],
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Số lượt truy cập'
          },
          ticks: {
            beginAtZero: true,
            callback: function(value, index, values) {
              if(parseInt(value) >= 1000){
                return `${(value/1000).toString()} k`;
              } else {
                return value;
              }
            }
          }
        }]
      },
      tooltips: {
        callbacks: {
          title: function(tooltipItem, data) {
            return `Tháng ${data['labels'][tooltipItem[0]['index']]}`;
          },
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            label += Math.round(tooltipItem.yLabel * 100) / 100;
            return label;
          }
        }
      }
    }
  }),
  watch: {
    matHangId() {
      this.getData();
    },
    nam(){
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    },
    getData(){
      const app = this;
      axios.get("api/v1/public/report-siteview-in-currentyear")
        .then(response => {
          app.chartdata2.labels = [];
          app.chartdata2.datasets[0].data = [];
          app.chartdata2.datasets[1].data = [];
          
          let items = response.data;
          for(let i=1; i<=12; i++){
            app.chartdata2.labels.push(i);
            let valObj = items.filter(function(elem){
              if(elem.month == i) return elem;
            });
            if(valObj.length > 0){
              app.chartdata2.datasets[0].data.push(parseInt(valObj[0].num));
              app.chartdata2.datasets[1].data.push(parseInt(valObj[0].num));
            } else {
              app.chartdata2.datasets[0].data.push(0);
              app.chartdata2.datasets[1].data.push(0);
            }
          }
          this.renderChart(this.chartdata2, this.options);
          this.$emit('finish');
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>
<style scoped>
  canvas {
    position: absolute;
    max-height: 97%;
    max-width: 100%;
  }
</style>